import React from 'react';

const MetadataModal = ({ show, onClose, metadata }) => {
  if (!show || !metadata) return null;

  return (
    <div className="metadata-modal-overlay" onClick={onClose}>
      <div className="metadata-modal" onClick={(e) => e.stopPropagation()}>
        <div className="metadata-modal-header">
          <h3>🗺️ Result Metadata</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="metadata-modal-body">
          <pre>{JSON.stringify(metadata, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
};

export default MetadataModal;

